var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-checkbox"},[_c('div',{},[_c('div',{staticClass:"pills-container"},[_c('button',{staticClass:"pills-check-btn",class:{ active: _vm.checked },style:({ borderColor: _vm.border }),attrs:{"disabled":false},on:{"click":function (e) {
            _vm.checkboxClick(_vm.id, _vm.title);
          }}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12034936","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/MultistepFormForFinder/PillsCheck.vue
// module id = 1983
// module chunks = 1